<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-btn :x-small="small" :color="CustomerStyle.TypeClass[type]">
    {{type}}
  </v-btn>

</template>
<style lang="scss" scoped>

</style>

<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'
  import {CustomerStyle} from './Const'

  @Component({
    components: {},
  })
  export default class TypeBadge extends Vue {
    @Prop() type: string|null
    @Prop({default: false}) small: boolean
    CustomerStyle = CustomerStyle

  }

</script>
